/* ============================================================
   NOBO PETS — THEME JAVASCRIPT
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ---- MOBILE MENU ----
  const menuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  const menuClose = document.querySelector('.mobile-menu__close');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      mobileMenu.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }

  if (menuClose && mobileMenu) {
    menuClose.addEventListener('click', () => {
      mobileMenu.classList.remove('open');
      document.body.style.overflow = '';
    });
  }

  // ---- SCROLL ANIMATIONS ----
  const fadeEls = document.querySelectorAll('.fade-up');

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });

    fadeEls.forEach(el => observer.observe(el));
  } else {
    fadeEls.forEach(el => el.classList.add('visible'));
  }

  // ---- PRODUCT GALLERY THUMBNAILS ----
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImg = document.querySelector('.product-gallery__main img');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg) {
        const newSrc = thumb.querySelector('img').src;
        mainImg.src = newSrc;
      }
    });
  });

  // ---- COLOR SWATCHES ----
  const swatches = document.querySelectorAll('.color-swatch');
  const colorLabel = document.querySelector('.color-label-text');

  swatches.forEach(swatch => {
    swatch.addEventListener('click', () => {
      swatches.forEach(s => s.classList.remove('active'));
      swatch.classList.add('active');
      if (colorLabel) {
        colorLabel.textContent = swatch.dataset.color || '';
      }
    });
  });

  // ---- QUANTITY SELECTOR ----
  const qtyMinus = document.querySelectorAll('.qty-minus');
  const qtyPlus = document.querySelectorAll('.qty-plus');

  qtyMinus.forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('.quantity-input');
      if (input) {
        const val = parseInt(input.value) || 1;
        if (val > 1) input.value = val - 1;
      }
    });
  });

  qtyPlus.forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('.quantity-input');
      if (input) {
        const val = parseInt(input.value) || 1;
        input.value = val + 1;
      }
    });
  });

  // ---- STICKY HEADER SHADOW ----
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 4px 24px rgba(0,0,0,0.3)';
      } else {
        header.style.boxShadow = 'none';
      }
    });
  }

  // ---- SMOOTH SCROLL FOR ANCHOR LINKS ----
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ---- ANNOUNCEMENT BAR DUPLICATE FOR SEAMLESS LOOP ----
  const track = document.querySelector('.announcement-bar__track');
  if (track) {
    const clone = track.cloneNode(true);
    track.parentElement.appendChild(clone);
  }

});
